'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import type { CurrentUser } from '@qogita/canary-client'
import { Anchor } from '@qogita/ui/v2/anchor'
import { Button } from '@qogita/ui/v2/button'
import {
  Modal,
  ModalActions,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@qogita/ui/v2/modal'
import { Separator } from '@qogita/ui/v2/separator'
import { useState } from 'react'
import { EMAILS } from 'src/core/constants/copy'
import { ONE_DAY_MS } from 'src/core/constants/time'

const SHOW_MODAL_AGAIN_INTERNAL = ONE_DAY_MS
const lastTimeModalShownlocalStorageKeyForUserQId = (
  userQid: CurrentUser['qid'],
) => `PausedSellerReasonModal::lastTimeShown:${userQid}`

const shouldShowModalAgain = (userQid: CurrentUser['qid']) => {
  const lastTimeModalWasOpenedTimestamp = localStorage.getItem(
    lastTimeModalShownlocalStorageKeyForUserQId(userQid),
  )

  if (!lastTimeModalWasOpenedTimestamp) return true

  // This compares the last time the modal was opened timestamp with the interval set by SHOW_MODAL_AGAIN_INTERNAL.
  return (
    Date.now() - Number(lastTimeModalWasOpenedTimestamp) >
    SHOW_MODAL_AGAIN_INTERNAL
  )
}

const updateLastTimeModalWasOpened = (userQid: string): void => {
  localStorage.setItem(
    lastTimeModalShownlocalStorageKeyForUserQId(userQid),
    String(Date.now()),
  )
}

const useModalStateWithLocalStorage = ({ user }: { user: CurrentUser }) => {
  const [showPausedModal, setShowPausedModal] = useState<boolean>(
    shouldShowModalAgain(user.qid),
  )

  const onClose = () => {
    updateLastTimeModalWasOpened(user.qid)
    setShowPausedModal(false)
  }

  return [showPausedModal, onClose] as const
}

export const PausedSellerReasonModal = ({ user }: { user: CurrentUser }) => {
  const [showPausedSellerReason, onDismissPausedSellerReasonModal] =
    useModalStateWithLocalStorage({ user })

  if (user.sellerStatus !== 'PAUSED' || !user.pauseReason) {
    return null
  }

  if (user.pauseReason === 'SELLER_OUT_OUF_OFFICE') {
    return (
      <Modal
        open={showPausedSellerReason}
        onOpenChange={onDismissPausedSellerReasonModal}
      >
        <ModalContent>
          <ModalHeader>
            <ModalTitle>Your Qogita account has been paused</ModalTitle>
          </ModalHeader>
          {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
          <ModalBody className="flex flex-col gap-6">
            {user.expectedPauseEnd ? (
              <h3 className="mb-2 text-base font-medium text-gray-700">
                You requested not to receive new orders during your
                facility-closure
              </h3>
            ) : null}

            <p className="text-base text-gray-700">
              If you would like to unpause your account please contact{' '}
              <Anchor
                variant="inline-text"
                href={`mailto:${EMAILS.success}`}
                rumActionName="PausedSellerModal Contact Us"
              >
                {EMAILS.success}
              </Anchor>
            </p>

            <Separator orientation="horizontal" />
            <p className="text-base text-gray-700">
              You can still interact with the portal but you will receive no new
              orders until this is resolved.
            </p>
          </ModalBody>
          <ModalFooter>
            <ModalActions>
              <Anchor
                variant="outlined"
                href={`mailto:${EMAILS.procurement}`}
                rumActionName="PausedSellerModal Contact Us"
              >
                Contact Us
              </Anchor>

              <Button onClick={onDismissPausedSellerReasonModal}>
                Continue to Portal
              </Button>
            </ModalActions>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  // if the backend sends a reason that we don't have a component for, don't show the modal
  return null
}
